import * as actions from "actions";
import * as api from "TamtamAPI";
import { setNewsletterChannel } from "../actions/currentCampaign";
import {
  formatChannel,
  enrichExpertsWithNewsletterImage,
} from "../../services/channel";

export const fetchNewsletterChannel = (channelId) => {
  return (dispatch, getState) => {
    if (!channelId) {
      dispatch(setNewsletterChannel(null));
      return Promise.resolve(null);
    }

    const { token, user } = getState().auth;
    const language = getState().currentCampaign.email.language || "fr";

    return api
      .getChannel({ token, channelId, language, userId: user?.id })
      .then(async (res) => {
        const chain = res?.data?.data?.[0] || null;
        const channel = chain ? formatChannel(chain, language) : null;
        if (channel) {
          await enrichExpertsWithNewsletterImage(channel.experts);
        }

        dispatch(setNewsletterChannel(channel));
        return channel;
      })
      .catch((error) => {
        console.error("Error fetching newsletter channel:", error);
        dispatch(setNewsletterChannel(null));
        return null;
      });
  };
};

export const fetchNewsletterUAArticles = () => {
  return (dispatch, getState) => {
    const { currentClient, token } = getState().auth;
    const clientId = currentClient.id;

    return dispatch(
      actions.getNewsletterArticles(
        api.getNewsletterArticles({
          token,
          clientId,
        }),
      ),
    );
  };
};
export const fetchNewsletterNumberByArticleId = (articleNewsletterId) => {
  return async (dispatch, getState) => {
    if (!articleNewsletterId) {
      return null;
    }
    const { token } = getState().auth;
    try {
      const resp = await api.getNewsletterArticleById({
        token,
        id: articleNewsletterId,
      });
      return resp?.data?.data?.[0]?.newsletterNumber || null;
    } catch (error) {
      console.error("Numero de newsletter introuvable :", error);
      return null;
    }
  };
};

export const fetchNewsletterUAArticlesByPeriod = (data) => {
  return (dispatch, getState) => {
    const { currentClient, token } = getState().auth;
    const { periodConfig, month, year, communityId,newsletterNumber,plan } = data;
    const clientId = communityId ? communityId : currentClient.id;

    return dispatch(
      actions.getNewsletterArticlesByPeriod(
        api.getNewsletterArticlesByPeriod({
          token,
          clientId,
          periodConfig,
          month,
          year,
          newsletterNumber,
          plan,
        }),
      ),
    );
  };
};

export const setIsUsedNewsletterArticles = (articleNewsletterId) => {
  return (dispatch, getState) => {
    const { token, currentClient } = getState().auth;
    const clientId = currentClient?.id;

    return dispatch(
      actions.updateIsUsedNewsletterArticles(
        api.updateIsUsedNewsletterArticles({
          token,
          articleNewsletterId,
          clientId,
        }),
      ),
    );
  };
};
